export default {"src":"/_next/static/media/Stroke_n.2b95255a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};